// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * AFF Portal - Design System
 * Modern, professional design system for admin interface
 * Based on senior-level design principles and best practices
 */

:root {
  /* Modern Color Scheme - Orange & Charcoal Brand */
  --primary-50: #FFF7ED;
  --primary-100: #FFEAD5;
  --primary-200: #FED7AA;
  --primary-300: #FDBA74;
  --primary-400: #FB923C;
  --primary-500: #F97316;
  --primary-600: #EA580C;
  --primary-700: #C2410C;
  --primary-800: #9A3412;
  --primary-900: #7C2D12;

  --secondary-50: #F5F6F7;
  --secondary-100: #E7E9EC;
  --secondary-200: #D2D6DB;
  --secondary-300: #B5BBC3;
  --secondary-400: #8C94A0;
  --secondary-500: #556070;
  --secondary-600: #3A4150;
  --secondary-700: #252A33;
  --secondary-800: #14181E;
  --secondary-900: #0B0B0C;

  --success-50: #f0fdf4;
  --success-100: #dcfce7;
  --success-200: #bbf7d0;
  --success-300: #86efac;
  --success-400: #4ade80;
  --success-500: #22c55e;
  --success-600: #16a34a;
  --success-700: #15803d;
  --success-800: #166534;
  --success-900: #14532d;

  --warning-50: #fffbeb;
  --warning-100: #fef3c7;
  --warning-200: #fde68a;
  --warning-300: #fcd34d;
  --warning-400: #fbbf24;
  --warning-500: #f59e0b;
  --warning-600: #d97706;
  --warning-700: #b45309;
  --warning-800: #92400e;
  --warning-900: #78350f;

  --error-50: #fef2f2;
  --error-100: #fee2e2;
  --error-200: #fecaca;
  --error-300: #fca5a5;
  --error-400: #f87171;
  --error-500: #ef4444;
  --error-600: #dc2626;
  --error-700: #b91c1c;
  --error-800: #991b1b;
  --error-900: #7f1d1d;

  --info-50: #f0f9ff;
  --info-100: #e0f2fe;
  --info-200: #bae6fd;
  --info-300: #7dd3fc;
  --info-400: #38bdf8;
  --info-500: #0D3B66;
  --info-600: #0B3158;
  --info-700: #092847;
  --info-800: #075985;
  --info-900: #0c4a6e;

  --neutral-50: #f9fafb;
  --neutral-100: #f3f4f6;
  --neutral-200: #e5e7eb;
  --neutral-300: #d1d5db;
  --neutral-400: #9ca3af;
  --neutral-500: #6b7280;
  --neutral-600: #4b5563;
  --neutral-700: #374151;
  --neutral-800: #1f2937;
  --neutral-900: #111827;

  /* Typography */
  --font-family-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  --font-family-mono: 'JetBrains Mono', 'Fira Code', 'Monaco', 'Consolas', monospace;

  --text-xs: 0.75rem;
  /* 12px */
  --text-sm: 0.875rem;
  /* 14px */
  --text-base: 1rem;
  /* 16px */
  --text-lg: 1.125rem;
  /* 18px */
  --text-xl: 1.25rem;
  /* 20px */
  --text-2xl: 1.5rem;
  /* 24px */
  --text-3xl: 1.875rem;
  /* 30px */
  --text-4xl: 2.25rem;
  /* 36px */
  --text-5xl: 3rem;
  /* 48px */

  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;

  --line-height-tight: 1.25;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.75;

  /* Spacing */
  --space-1: 0.25rem;
  /* 4px */
  --space-2: 0.5rem;
  /* 8px */
  --space-3: 0.75rem;
  /* 12px */
  --space-4: 1rem;
  /* 16px */
  --space-5: 1.25rem;
  /* 20px */
  --space-6: 1.5rem;
  /* 24px */
  --space-8: 2rem;
  /* 32px */
  --space-10: 2.5rem;
  /* 40px */
  --space-12: 3rem;
  /* 48px */
  --space-16: 4rem;
  /* 64px */
  --space-20: 5rem;
  /* 80px */
  --space-24: 6rem;
  /* 96px */

  /* Border Radius */
  --radius-none: 0;
  --radius-sm: 0.125rem;
  /* 2px */
  --radius-base: 0.25rem;
  /* 4px */
  --radius-md: 0.375rem;
  /* 6px */
  --radius-lg: 0.5rem;
  /* 8px */
  --radius-xl: 0.75rem;
  /* 12px */
  --radius-2xl: 1rem;
  /* 16px */
  --radius-3xl: 1.5rem;
  /* 24px */
  --radius-full: 9999px;

  /* Shadows */
  --shadow-xs: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-base: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

  /* Transitions */
  --transition-fast: 150ms ease-in-out;
  --transition-base: 250ms ease-in-out;
  --transition-slow: 350ms ease-in-out;

  /* Z-Index */
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
  --z-toast: 1080;

  /* Brand Gradients - Orange & Charcoal Theme */
  --brand-gradient: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  --brand-gradient-dark: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);
  --brand-wash: linear-gradient(135deg, #FFF7ED 0%, #FFEAD5 100%);

  /* Background Gradients */
  --auth-background: linear-gradient(135deg, #FFFFFF 0%, #FFF7ED 60%, #FFEAD5 100%);
  --dashboard-background: linear-gradient(135deg, #FFFFFF 0%, #F7F7F8 100%);
}

/* Reset and Base Styles */
* {
  box-sizing: border-box;
}

html {
  font-size: 16px;
  line-height: var(--line-height-normal);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: var(--font-family-sans);
  font-size: var(--text-base);
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-normal);
  color: var(--neutral-800);
  background-color: var(--neutral-50);
  margin: 0;
  padding: 0;
}

/* Typography Classes */
.text-xs {
  font-size: var(--text-xs);
}

.text-sm {
  font-size: var(--text-sm);
}

.text-base {
  font-size: var(--text-base);
}

.text-lg {
  font-size: var(--text-lg);
}

.text-xl {
  font-size: var(--text-xl);
}

.text-2xl {
  font-size: var(--text-2xl);
}

.text-3xl {
  font-size: var(--text-3xl);
}

.text-4xl {
  font-size: var(--text-4xl);
}

.text-5xl {
  font-size: var(--text-5xl);
}

.font-normal {
  font-weight: var(--font-weight-normal);
}

.font-medium {
  font-weight: var(--font-weight-medium);
}

.font-semibold {
  font-weight: var(--font-weight-semibold);
}

.font-bold {
  font-weight: var(--font-weight-bold);
}

.font-extrabold {
  font-weight: var(--font-weight-extrabold);
}

.leading-tight {
  line-height: var(--line-height-tight);
}

.leading-normal {
  line-height: var(--line-height-normal);
}

.leading-relaxed {
  line-height: var(--line-height-relaxed);
}

/* Color Classes */
.text-primary {
  color: var(--primary-600);
}

.text-secondary {
  color: var(--secondary-600);
}

.text-success {
  color: var(--success-600);
}

.text-warning {
  color: var(--warning-600);
}

.text-error {
  color: var(--error-600);
}

.text-info {
  color: var(--info-600);
}

.text-neutral-500 {
  color: var(--neutral-500);
}

.text-neutral-600 {
  color: var(--neutral-600);
}

.text-neutral-700 {
  color: var(--neutral-700);
}

.text-neutral-800 {
  color: var(--neutral-800);
}

.text-neutral-900 {
  color: var(--neutral-900);
}

.bg-primary {
  background-color: var(--primary-600);
}

.bg-secondary {
  background-color: var(--secondary-600);
}

.bg-success {
  background-color: var(--success-600);
}

.bg-warning {
  background-color: var(--warning-600);
}

.bg-error {
  background-color: var(--error-600);
}

.bg-info {
  background-color: var(--info-600);
}

/* Spacing Classes */
.p-1 {
  padding: var(--space-1);
}

.p-2 {
  padding: var(--space-2);
}

.p-3 {
  padding: var(--space-3);
}

.p-4 {
  padding: var(--space-4);
}

.p-5 {
  padding: var(--space-5);
}

.p-6 {
  padding: var(--space-6);
}

.p-8 {
  padding: var(--space-8);
}

.m-1 {
  margin: var(--space-1);
}

.m-2 {
  margin: var(--space-2);
}

.m-3 {
  margin: var(--space-3);
}

.m-4 {
  margin: var(--space-4);
}

.m-5 {
  margin: var(--space-5);
}

.m-6 {
  margin: var(--space-6);
}

.m-8 {
  margin: var(--space-8);
}

/* Border Radius Classes */
.rounded-none {
  border-radius: var(--radius-none);
}

.rounded-sm {
  border-radius: var(--radius-sm);
}

.rounded {
  border-radius: var(--radius-base);
}

.rounded-md {
  border-radius: var(--radius-md);
}

.rounded-lg {
  border-radius: var(--radius-lg);
}

.rounded-xl {
  border-radius: var(--radius-xl);
}

.rounded-2xl {
  border-radius: var(--radius-2xl);
}

.rounded-3xl {
  border-radius: var(--radius-3xl);
}

.rounded-full {
  border-radius: var(--radius-full);
}

/* Shadow Classes */
.shadow-xs {
  box-shadow: var(--shadow-xs);
}

.shadow-sm {
  box-shadow: var(--shadow-sm);
}

.shadow {
  box-shadow: var(--shadow-base);
}

.shadow-md {
  box-shadow: var(--shadow-md);
}

.shadow-lg {
  box-shadow: var(--shadow-lg);
}

.shadow-xl {
  box-shadow: var(--shadow-xl);
}

.shadow-2xl {
  box-shadow: var(--shadow-2xl);
}

/* Transition Classes */
.transition-fast {
  transition: all var(--transition-fast);
}

.transition {
  transition: all var(--transition-base);
}

.transition-slow {
  transition: all var(--transition-slow);
}

/* Utility Classes */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Focus Styles */
.focus-ring {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-ring:focus {
  outline: 2px solid var(--primary-600);
  outline-offset: 2px;
}

/* Animation Keyframes */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

/* Animation Classes */
.animate-fade-in {
  animation: fadeIn 0.3s ease-out;
}

.animate-fade-in-up {
  animation: fadeInUp 0.4s ease-out;
}

.animate-fade-in-down {
  animation: fadeInDown 0.4s ease-out;
}

.animate-slide-in-left {
  animation: slideInLeft 0.4s ease-out;
}

.animate-slide-in-right {
  animation: slideInRight 0.4s ease-out;
}

.animate-scale-in {
  animation: scaleIn 0.3s ease-out;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Responsive Design */
@media (max-width: 640px) {
  .sm\\:text-sm {
    font-size: var(--text-sm);
  }

  .sm\\:text-base {
    font-size: var(--text-base);
  }

  .sm\\:p-2 {
    padding: var(--space-2);
  }

  .sm\\:p-4 {
    padding: var(--space-4);
  }
}

@media (max-width: 768px) {
  .md\\:text-lg {
    font-size: var(--text-lg);
  }

  .md\\:text-xl {
    font-size: var(--text-xl);
  }

  .md\\:p-6 {
    padding: var(--space-6);
  }

  .md\\:p-8 {
    padding: var(--space-8);
  }
}

@media (max-width: 1024px) {
  .lg\\:text-xl {
    font-size: var(--text-xl);
  }

  .lg\\:text-2xl {
    font-size: var(--text-2xl);
  }

  .lg\\:p-8 {
    padding: var(--space-8);
  }

  .lg\\:p-10 {
    padding: var(--space-10);
  }
}

@media (max-width: 1280px) {
  .xl\\:text-2xl {
    font-size: var(--text-2xl);
  }

  .xl\\:text-3xl {
    font-size: var(--text-3xl);
  }

  .xl\\:p-10 {
    padding: var(--space-10);
  }

  .xl\\:p-12 {
    padding: var(--space-12);
  }
}

/* ========================================
   COMMON COMPONENT STYLES
   ======================================== */

/* Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-base);
  white-space: nowrap;
  min-width: 100px;
  line-height: 1;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--primary-600);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: var(--primary-700);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-secondary {
  background: var(--neutral-500);
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background: var(--neutral-600);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-success {
  background: var(--success-600);
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: var(--success-700);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-danger {
  background: var(--error-600);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: var(--error-700);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-warning {
  background: var(--warning-600);
  color: white;
}

.btn-warning:hover:not(:disabled) {
  background: var(--warning-700);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-outline {
  background: transparent;
  color: var(--primary-600);
  border: 2px solid var(--primary-600);
}

.btn-outline:hover:not(:disabled) {
  background: var(--primary-600);
  color: white;
}

.btn-sm {
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-xs);
  min-width: 80px;
}

.btn-lg {
  padding: var(--space-4) var(--space-6);
  font-size: var(--text-base);
  min-width: 120px;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  padding: var(--space-5);
}

.modal-container {
  background: white;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: scaleIn 0.3s ease-out;
}

.modal-header {
  background: var(--neutral-50);
  padding: var(--space-5) var(--space-6);
  border-bottom: 1px solid var(--neutral-200);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.modal-header h2 {
  margin: 0;
  font-size: var(--text-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-800);
}

.modal-close {
  background: none;
  border: none;
  font-size: var(--text-2xl);
  color: var(--neutral-500);
  cursor: pointer;
  padding: var(--space-1);
  border-radius: var(--radius-md);
  transition: all var(--transition-base);
  line-height: 1;
}

.modal-close:hover {
  background: var(--neutral-200);
  color: var(--neutral-700);
}

.modal-body {
  padding: var(--space-6);
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  background: var(--neutral-50);
  padding: var(--space-5) var(--space-6);
  border-top: 1px solid var(--neutral-200);
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  flex-shrink: 0;
}

/* Form Styles */
.form-section {
  margin-bottom: var(--space-8);
}

.form-section:last-child {
  margin-bottom: 0;
}

.form-section h3 {
  margin: 0 0 var(--space-4) 0;
  font-size: var(--text-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-800);
  padding-bottom: var(--space-2);
  border-bottom: 2px solid var(--neutral-200);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.form-group label {
  font-weight: var(--font-weight-medium);
  color: var(--neutral-700);
  font-size: var(--text-sm);
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: var(--space-3) var(--space-4);
  border: 2px solid var(--neutral-300);
  border-radius: var(--radius-md);
  font-size: var(--text-base);
  transition: all var(--transition-base);
  background: white;
  font-family: inherit;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-600);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.form-group input.error,
.form-group select.error,
.form-group textarea.error {
  border-color: var(--error-500);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.form-group input:disabled,
.form-group select:disabled,
.form-group textarea:disabled {
  background: var(--neutral-100);
  color: var(--neutral-500);
  cursor: not-allowed;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

/* Checkbox Styles */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  cursor: pointer;
  font-size: var(--text-sm);
  color: var(--neutral-700);
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: pointer;
}

.checkmark {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  background: white;
  border: 2px solid var(--neutral-300);
  border-radius: var(--radius-sm);
  transition: all var(--transition-base);
}

.checkbox-label input[type="checkbox"]:checked+.checkmark {
  background: var(--primary-600);
  border-color: var(--primary-600);
}

.checkbox-label input[type="checkbox"]:checked+.checkmark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-full);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-badge.active,
.status-badge.published,
.status-badge.completed {
  background: var(--success-100);
  color: var(--success-800);
}

.status-badge.inactive,
.status-badge.draft,
.status-badge.pending {
  background: var(--warning-100);
  color: var(--warning-800);
}

.status-badge.cancelled,
.status-badge.failed,
.status-badge.rejected {
  background: var(--error-100);
  color: var(--error-800);
}

.status-badge.processing,
.status-badge.in-progress {
  background: var(--info-100);
  color: var(--info-800);
}

/* Unified Status Badges */
.unified-status-badge {
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-full);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.unified-status-badge.verified,
.unified-status-badge.approved,
.unified-status-badge.active {
  background: var(--success-100);
  color: var(--success-800);
}

.unified-status-badge.unverified,
.unified-status-badge.pending,
.unified-status-badge.inactive {
  background: var(--warning-100);
  color: var(--warning-800);
}

.unified-status-badge.rejected,
.unified-status-badge.failed {
  background: var(--error-100);
  color: var(--error-800);
}

.unified-status-badge.superuser {
  background: var(--primary-100);
  color: var(--primary-800);
}

.unified-status-badge.staff {
  background: var(--info-100);
  color: var(--info-800);
}

.unified-status-badge.regular {
  background: var(--neutral-100);
  color: var(--neutral-800);
}

.unified-status-badge.pending {
  background: var(--warning-100);
  color: var(--warning-800);
}

.unified-status-badge.approved {
  background: var(--success-100);
  color: var(--success-800);
}

.unified-status-badge.rejected {
  background: var(--error-100);
  color: var(--error-800);
}

/* Responsive Design for Common Components */
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
  }

  .form-row:first-child {
    grid-template-columns: 1fr;
  }

  .modal-container {
    max-width: 700px;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    padding: var(--space-3);
  }

  .modal-container {
    max-height: 95vh;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding: var(--space-4);
  }

  .modal-footer {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/design-system.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,kDAAkD;EAClD,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,eAAe;EACf,iIAAiI;EACjI,kFAAkF;;EAElF,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;;EAET,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;;EAE5B,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;;EAE3B,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,SAAS;;EAET,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,qBAAqB;;EAErB,YAAY;EACZ,4CAA4C;EAC5C,4EAA4E;EAC5E,oFAAoF;EACpF,oFAAoF;EACpF,sFAAsF;EACtF,kDAAkD;EAClD,mDAAmD;;EAEnD,gBAAgB;EAChB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;;EAEf,8CAA8C;EAC9C,mEAAmE;EACnE,wEAAwE;EACxE,+DAA+D;;EAE/D,yBAAyB;EACzB,iFAAiF;EACjF,yEAAyE;AAC3E;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sCAAsC;EACtC,sCAAsC;EACtC,yBAAyB;EACzB,mCAAmC;EACnC,SAAS;EACT,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;6CAE6C;;AAE7C,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,2CAA2C;EAC3C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,wCAAwC;EACxC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;;;EAGE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/**\n * AFF Portal - Design System\n * Modern, professional design system for admin interface\n * Based on senior-level design principles and best practices\n */\n\n:root {\n  /* Modern Color Scheme - Orange & Charcoal Brand */\n  --primary-50: #FFF7ED;\n  --primary-100: #FFEAD5;\n  --primary-200: #FED7AA;\n  --primary-300: #FDBA74;\n  --primary-400: #FB923C;\n  --primary-500: #F97316;\n  --primary-600: #EA580C;\n  --primary-700: #C2410C;\n  --primary-800: #9A3412;\n  --primary-900: #7C2D12;\n\n  --secondary-50: #F5F6F7;\n  --secondary-100: #E7E9EC;\n  --secondary-200: #D2D6DB;\n  --secondary-300: #B5BBC3;\n  --secondary-400: #8C94A0;\n  --secondary-500: #556070;\n  --secondary-600: #3A4150;\n  --secondary-700: #252A33;\n  --secondary-800: #14181E;\n  --secondary-900: #0B0B0C;\n\n  --success-50: #f0fdf4;\n  --success-100: #dcfce7;\n  --success-200: #bbf7d0;\n  --success-300: #86efac;\n  --success-400: #4ade80;\n  --success-500: #22c55e;\n  --success-600: #16a34a;\n  --success-700: #15803d;\n  --success-800: #166534;\n  --success-900: #14532d;\n\n  --warning-50: #fffbeb;\n  --warning-100: #fef3c7;\n  --warning-200: #fde68a;\n  --warning-300: #fcd34d;\n  --warning-400: #fbbf24;\n  --warning-500: #f59e0b;\n  --warning-600: #d97706;\n  --warning-700: #b45309;\n  --warning-800: #92400e;\n  --warning-900: #78350f;\n\n  --error-50: #fef2f2;\n  --error-100: #fee2e2;\n  --error-200: #fecaca;\n  --error-300: #fca5a5;\n  --error-400: #f87171;\n  --error-500: #ef4444;\n  --error-600: #dc2626;\n  --error-700: #b91c1c;\n  --error-800: #991b1b;\n  --error-900: #7f1d1d;\n\n  --info-50: #f0f9ff;\n  --info-100: #e0f2fe;\n  --info-200: #bae6fd;\n  --info-300: #7dd3fc;\n  --info-400: #38bdf8;\n  --info-500: #0D3B66;\n  --info-600: #0B3158;\n  --info-700: #092847;\n  --info-800: #075985;\n  --info-900: #0c4a6e;\n\n  --neutral-50: #f9fafb;\n  --neutral-100: #f3f4f6;\n  --neutral-200: #e5e7eb;\n  --neutral-300: #d1d5db;\n  --neutral-400: #9ca3af;\n  --neutral-500: #6b7280;\n  --neutral-600: #4b5563;\n  --neutral-700: #374151;\n  --neutral-800: #1f2937;\n  --neutral-900: #111827;\n\n  /* Typography */\n  --font-family-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  --font-family-mono: 'JetBrains Mono', 'Fira Code', 'Monaco', 'Consolas', monospace;\n\n  --text-xs: 0.75rem;\n  /* 12px */\n  --text-sm: 0.875rem;\n  /* 14px */\n  --text-base: 1rem;\n  /* 16px */\n  --text-lg: 1.125rem;\n  /* 18px */\n  --text-xl: 1.25rem;\n  /* 20px */\n  --text-2xl: 1.5rem;\n  /* 24px */\n  --text-3xl: 1.875rem;\n  /* 30px */\n  --text-4xl: 2.25rem;\n  /* 36px */\n  --text-5xl: 3rem;\n  /* 48px */\n\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n\n  --line-height-tight: 1.25;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.75;\n\n  /* Spacing */\n  --space-1: 0.25rem;\n  /* 4px */\n  --space-2: 0.5rem;\n  /* 8px */\n  --space-3: 0.75rem;\n  /* 12px */\n  --space-4: 1rem;\n  /* 16px */\n  --space-5: 1.25rem;\n  /* 20px */\n  --space-6: 1.5rem;\n  /* 24px */\n  --space-8: 2rem;\n  /* 32px */\n  --space-10: 2.5rem;\n  /* 40px */\n  --space-12: 3rem;\n  /* 48px */\n  --space-16: 4rem;\n  /* 64px */\n  --space-20: 5rem;\n  /* 80px */\n  --space-24: 6rem;\n  /* 96px */\n\n  /* Border Radius */\n  --radius-none: 0;\n  --radius-sm: 0.125rem;\n  /* 2px */\n  --radius-base: 0.25rem;\n  /* 4px */\n  --radius-md: 0.375rem;\n  /* 6px */\n  --radius-lg: 0.5rem;\n  /* 8px */\n  --radius-xl: 0.75rem;\n  /* 12px */\n  --radius-2xl: 1rem;\n  /* 16px */\n  --radius-3xl: 1.5rem;\n  /* 24px */\n  --radius-full: 9999px;\n\n  /* Shadows */\n  --shadow-xs: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  --shadow-base: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --shadow-xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n\n  /* Transitions */\n  --transition-fast: 150ms ease-in-out;\n  --transition-base: 250ms ease-in-out;\n  --transition-slow: 350ms ease-in-out;\n\n  /* Z-Index */\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal-backdrop: 1040;\n  --z-modal: 1050;\n  --z-popover: 1060;\n  --z-tooltip: 1070;\n  --z-toast: 1080;\n\n  /* Brand Gradients - Orange & Charcoal Theme */\n  --brand-gradient: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  --brand-gradient-dark: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);\n  --brand-wash: linear-gradient(135deg, #FFF7ED 0%, #FFEAD5 100%);\n\n  /* Background Gradients */\n  --auth-background: linear-gradient(135deg, #FFFFFF 0%, #FFF7ED 60%, #FFEAD5 100%);\n  --dashboard-background: linear-gradient(135deg, #FFFFFF 0%, #F7F7F8 100%);\n}\n\n/* Reset and Base Styles */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 16px;\n  line-height: var(--line-height-normal);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  font-family: var(--font-family-sans);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-normal);\n  line-height: var(--line-height-normal);\n  color: var(--neutral-800);\n  background-color: var(--neutral-50);\n  margin: 0;\n  padding: 0;\n}\n\n/* Typography Classes */\n.text-xs {\n  font-size: var(--text-xs);\n}\n\n.text-sm {\n  font-size: var(--text-sm);\n}\n\n.text-base {\n  font-size: var(--text-base);\n}\n\n.text-lg {\n  font-size: var(--text-lg);\n}\n\n.text-xl {\n  font-size: var(--text-xl);\n}\n\n.text-2xl {\n  font-size: var(--text-2xl);\n}\n\n.text-3xl {\n  font-size: var(--text-3xl);\n}\n\n.text-4xl {\n  font-size: var(--text-4xl);\n}\n\n.text-5xl {\n  font-size: var(--text-5xl);\n}\n\n.font-normal {\n  font-weight: var(--font-weight-normal);\n}\n\n.font-medium {\n  font-weight: var(--font-weight-medium);\n}\n\n.font-semibold {\n  font-weight: var(--font-weight-semibold);\n}\n\n.font-bold {\n  font-weight: var(--font-weight-bold);\n}\n\n.font-extrabold {\n  font-weight: var(--font-weight-extrabold);\n}\n\n.leading-tight {\n  line-height: var(--line-height-tight);\n}\n\n.leading-normal {\n  line-height: var(--line-height-normal);\n}\n\n.leading-relaxed {\n  line-height: var(--line-height-relaxed);\n}\n\n/* Color Classes */\n.text-primary {\n  color: var(--primary-600);\n}\n\n.text-secondary {\n  color: var(--secondary-600);\n}\n\n.text-success {\n  color: var(--success-600);\n}\n\n.text-warning {\n  color: var(--warning-600);\n}\n\n.text-error {\n  color: var(--error-600);\n}\n\n.text-info {\n  color: var(--info-600);\n}\n\n.text-neutral-500 {\n  color: var(--neutral-500);\n}\n\n.text-neutral-600 {\n  color: var(--neutral-600);\n}\n\n.text-neutral-700 {\n  color: var(--neutral-700);\n}\n\n.text-neutral-800 {\n  color: var(--neutral-800);\n}\n\n.text-neutral-900 {\n  color: var(--neutral-900);\n}\n\n.bg-primary {\n  background-color: var(--primary-600);\n}\n\n.bg-secondary {\n  background-color: var(--secondary-600);\n}\n\n.bg-success {\n  background-color: var(--success-600);\n}\n\n.bg-warning {\n  background-color: var(--warning-600);\n}\n\n.bg-error {\n  background-color: var(--error-600);\n}\n\n.bg-info {\n  background-color: var(--info-600);\n}\n\n/* Spacing Classes */\n.p-1 {\n  padding: var(--space-1);\n}\n\n.p-2 {\n  padding: var(--space-2);\n}\n\n.p-3 {\n  padding: var(--space-3);\n}\n\n.p-4 {\n  padding: var(--space-4);\n}\n\n.p-5 {\n  padding: var(--space-5);\n}\n\n.p-6 {\n  padding: var(--space-6);\n}\n\n.p-8 {\n  padding: var(--space-8);\n}\n\n.m-1 {\n  margin: var(--space-1);\n}\n\n.m-2 {\n  margin: var(--space-2);\n}\n\n.m-3 {\n  margin: var(--space-3);\n}\n\n.m-4 {\n  margin: var(--space-4);\n}\n\n.m-5 {\n  margin: var(--space-5);\n}\n\n.m-6 {\n  margin: var(--space-6);\n}\n\n.m-8 {\n  margin: var(--space-8);\n}\n\n/* Border Radius Classes */\n.rounded-none {\n  border-radius: var(--radius-none);\n}\n\n.rounded-sm {\n  border-radius: var(--radius-sm);\n}\n\n.rounded {\n  border-radius: var(--radius-base);\n}\n\n.rounded-md {\n  border-radius: var(--radius-md);\n}\n\n.rounded-lg {\n  border-radius: var(--radius-lg);\n}\n\n.rounded-xl {\n  border-radius: var(--radius-xl);\n}\n\n.rounded-2xl {\n  border-radius: var(--radius-2xl);\n}\n\n.rounded-3xl {\n  border-radius: var(--radius-3xl);\n}\n\n.rounded-full {\n  border-radius: var(--radius-full);\n}\n\n/* Shadow Classes */\n.shadow-xs {\n  box-shadow: var(--shadow-xs);\n}\n\n.shadow-sm {\n  box-shadow: var(--shadow-sm);\n}\n\n.shadow {\n  box-shadow: var(--shadow-base);\n}\n\n.shadow-md {\n  box-shadow: var(--shadow-md);\n}\n\n.shadow-lg {\n  box-shadow: var(--shadow-lg);\n}\n\n.shadow-xl {\n  box-shadow: var(--shadow-xl);\n}\n\n.shadow-2xl {\n  box-shadow: var(--shadow-2xl);\n}\n\n/* Transition Classes */\n.transition-fast {\n  transition: all var(--transition-fast);\n}\n\n.transition {\n  transition: all var(--transition-base);\n}\n\n.transition-slow {\n  transition: all var(--transition-slow);\n}\n\n/* Utility Classes */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Focus Styles */\n.focus-ring {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.focus-ring:focus {\n  outline: 2px solid var(--primary-600);\n  outline-offset: 2px;\n}\n\n/* Animation Keyframes */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Animation Classes */\n.animate-fade-in {\n  animation: fadeIn 0.3s ease-out;\n}\n\n.animate-fade-in-up {\n  animation: fadeInUp 0.4s ease-out;\n}\n\n.animate-fade-in-down {\n  animation: fadeInDown 0.4s ease-out;\n}\n\n.animate-slide-in-left {\n  animation: slideInLeft 0.4s ease-out;\n}\n\n.animate-slide-in-right {\n  animation: slideInRight 0.4s ease-out;\n}\n\n.animate-scale-in {\n  animation: scaleIn 0.3s ease-out;\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Responsive Design */\n@media (max-width: 640px) {\n  .sm\\:text-sm {\n    font-size: var(--text-sm);\n  }\n\n  .sm\\:text-base {\n    font-size: var(--text-base);\n  }\n\n  .sm\\:p-2 {\n    padding: var(--space-2);\n  }\n\n  .sm\\:p-4 {\n    padding: var(--space-4);\n  }\n}\n\n@media (max-width: 768px) {\n  .md\\:text-lg {\n    font-size: var(--text-lg);\n  }\n\n  .md\\:text-xl {\n    font-size: var(--text-xl);\n  }\n\n  .md\\:p-6 {\n    padding: var(--space-6);\n  }\n\n  .md\\:p-8 {\n    padding: var(--space-8);\n  }\n}\n\n@media (max-width: 1024px) {\n  .lg\\:text-xl {\n    font-size: var(--text-xl);\n  }\n\n  .lg\\:text-2xl {\n    font-size: var(--text-2xl);\n  }\n\n  .lg\\:p-8 {\n    padding: var(--space-8);\n  }\n\n  .lg\\:p-10 {\n    padding: var(--space-10);\n  }\n}\n\n@media (max-width: 1280px) {\n  .xl\\:text-2xl {\n    font-size: var(--text-2xl);\n  }\n\n  .xl\\:text-3xl {\n    font-size: var(--text-3xl);\n  }\n\n  .xl\\:p-10 {\n    padding: var(--space-10);\n  }\n\n  .xl\\:p-12 {\n    padding: var(--space-12);\n  }\n}\n\n/* ========================================\n   COMMON COMPONENT STYLES\n   ======================================== */\n\n/* Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-4);\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n  cursor: pointer;\n  transition: all var(--transition-base);\n  white-space: nowrap;\n  min-width: 100px;\n  line-height: 1;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: var(--primary-600);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--primary-700);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-secondary {\n  background: var(--neutral-500);\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--neutral-600);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-success {\n  background: var(--success-600);\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background: var(--success-700);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-danger {\n  background: var(--error-600);\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: var(--error-700);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-warning {\n  background: var(--warning-600);\n  color: white;\n}\n\n.btn-warning:hover:not(:disabled) {\n  background: var(--warning-700);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--primary-600);\n  border: 2px solid var(--primary-600);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--primary-600);\n  color: white;\n}\n\n.btn-sm {\n  padding: var(--space-2) var(--space-3);\n  font-size: var(--text-xs);\n  min-width: 80px;\n}\n\n.btn-lg {\n  padding: var(--space-4) var(--space-6);\n  font-size: var(--text-base);\n  min-width: 120px;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--z-modal);\n  padding: var(--space-5);\n}\n\n.modal-container {\n  background: white;\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: scaleIn 0.3s ease-out;\n}\n\n.modal-header {\n  background: var(--neutral-50);\n  padding: var(--space-5) var(--space-6);\n  border-bottom: 1px solid var(--neutral-200);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: var(--text-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-800);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: var(--text-2xl);\n  color: var(--neutral-500);\n  cursor: pointer;\n  padding: var(--space-1);\n  border-radius: var(--radius-md);\n  transition: all var(--transition-base);\n  line-height: 1;\n}\n\n.modal-close:hover {\n  background: var(--neutral-200);\n  color: var(--neutral-700);\n}\n\n.modal-body {\n  padding: var(--space-6);\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  background: var(--neutral-50);\n  padding: var(--space-5) var(--space-6);\n  border-top: 1px solid var(--neutral-200);\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-3);\n  flex-shrink: 0;\n}\n\n/* Form Styles */\n.form-section {\n  margin-bottom: var(--space-8);\n}\n\n.form-section:last-child {\n  margin-bottom: 0;\n}\n\n.form-section h3 {\n  margin: 0 0 var(--space-4) 0;\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-800);\n  padding-bottom: var(--space-2);\n  border-bottom: 2px solid var(--neutral-200);\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--space-4);\n  margin-bottom: var(--space-4);\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.form-group label {\n  font-weight: var(--font-weight-medium);\n  color: var(--neutral-700);\n  font-size: var(--text-sm);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: var(--space-3) var(--space-4);\n  border: 2px solid var(--neutral-300);\n  border-radius: var(--radius-md);\n  font-size: var(--text-base);\n  transition: all var(--transition-base);\n  background: white;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-600);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.form-group input.error,\n.form-group select.error,\n.form-group textarea.error {\n  border-color: var(--error-500);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.form-group input:disabled,\n.form-group select:disabled,\n.form-group textarea:disabled {\n  background: var(--neutral-100);\n  color: var(--neutral-500);\n  cursor: not-allowed;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n/* Checkbox Styles */\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  cursor: pointer;\n  font-size: var(--text-sm);\n  color: var(--neutral-700);\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.checkmark {\n  position: relative;\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  background: white;\n  border: 2px solid var(--neutral-300);\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-base);\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark {\n  background: var(--primary-600);\n  border-color: var(--primary-600);\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark::after {\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-full);\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.status-badge.active,\n.status-badge.published,\n.status-badge.completed {\n  background: var(--success-100);\n  color: var(--success-800);\n}\n\n.status-badge.inactive,\n.status-badge.draft,\n.status-badge.pending {\n  background: var(--warning-100);\n  color: var(--warning-800);\n}\n\n.status-badge.cancelled,\n.status-badge.failed,\n.status-badge.rejected {\n  background: var(--error-100);\n  color: var(--error-800);\n}\n\n.status-badge.processing,\n.status-badge.in-progress {\n  background: var(--info-100);\n  color: var(--info-800);\n}\n\n/* Unified Status Badges */\n.unified-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-full);\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.unified-status-badge.verified,\n.unified-status-badge.approved,\n.unified-status-badge.active {\n  background: var(--success-100);\n  color: var(--success-800);\n}\n\n.unified-status-badge.unverified,\n.unified-status-badge.pending,\n.unified-status-badge.inactive {\n  background: var(--warning-100);\n  color: var(--warning-800);\n}\n\n.unified-status-badge.rejected,\n.unified-status-badge.failed {\n  background: var(--error-100);\n  color: var(--error-800);\n}\n\n.unified-status-badge.superuser {\n  background: var(--primary-100);\n  color: var(--primary-800);\n}\n\n.unified-status-badge.staff {\n  background: var(--info-100);\n  color: var(--info-800);\n}\n\n.unified-status-badge.regular {\n  background: var(--neutral-100);\n  color: var(--neutral-800);\n}\n\n.unified-status-badge.pending {\n  background: var(--warning-100);\n  color: var(--warning-800);\n}\n\n.unified-status-badge.approved {\n  background: var(--success-100);\n  color: var(--success-800);\n}\n\n.unified-status-badge.rejected {\n  background: var(--error-100);\n  color: var(--error-800);\n}\n\n/* Responsive Design for Common Components */\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .form-row:first-child {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-container {\n    max-width: 700px;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-overlay {\n    padding: var(--space-3);\n  }\n\n  .modal-container {\n    max-height: 95vh;\n  }\n\n  .modal-header,\n  .modal-body,\n  .modal-footer {\n    padding: var(--space-4);\n  }\n\n  .modal-footer {\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
